module.exports = __webpack_public_path__ + "img/htkb.90fef56a.png";